import { render, staticRenderFns } from "./LeadPrivateNotes.vue?vue&type=template&id=5d475d76"
import script from "./LeadPrivateNotes.vue?vue&type=script&lang=ts"
export * from "./LeadPrivateNotes.vue?vue&type=script&lang=ts"
import style0 from "./LeadPrivateNotes.vue?vue&type=style&index=0&id=5d475d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports